import filter from "./filter.module"

export default {
  filter,
}
